import {
  useDynamicConfigValue,
  useSupplierDynamicConfigFlag,
} from '@/hooks/use-dynamic-config-value';

export const useCatalogCategoryListsEnabled = () => {
  const catalogCategoryListsEnabled = useSupplierDynamicConfigFlag(
    'typesense_config',
    'catalog_category_lists',
  );
  const itemGroupsEnabled = useDynamicConfigValue('item_groups_enabled');

  // searchVariantPacks filters by variant_pack_group_id, which getSupplierCategoryItems doesn't return
  return Boolean(catalogCategoryListsEnabled && itemGroupsEnabled);
};
